// extracted by mini-css-extract-plugin
export default {"teachers_list":"CustomerList_teachers_list__7VPil","slot":"CustomerList_slot__YwV+D"};